/* eslint-disable max-len */
import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

const img = `
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 32 32">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_776" data-name="Rectangle 776" width="100%" height="100%" fill="rgba(255,255,255,0)"/>
    </clipPath>
  </defs>
  <g id="Group_3186" data-name="Group 3186" clip-path="url(#clip-path)">
    <g id="Group_3194" data-name="Group 3194">
      <path id="Path_1797" data-name="Path 1797" d="M28.667,14.667S23.236,25.333,15.333,25.333,2,14.667,2,14.667,7.431,4,15.333,4,28.667,14.667,28.667,14.667Z" transform="translate(0.667 1.333)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <path id="Path_1798" data-name="Path 1798" d="M20.333,13.667a6.665,6.665,0,1,1-1.952-4.715A6.667,6.667,0,0,1,20.333,13.667Z" transform="translate(2.333 2.333)" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="1"/>
      <path id="Subtraction_1" data-name="Subtraction 1" d="M-1131.5-187.336a3.168,3.168,0,0,1-3.165-3.165l.1-.1a2.373,2.373,0,0,0,.69.1,2.376,2.376,0,0,0,2.374-2.373,2.369,2.369,0,0,0-.1-.69l.1-.1a3.168,3.168,0,0,1,3.165,3.165A3.169,3.169,0,0,1-1131.5-187.336Z" transform="translate(1147.502 206.501)" fill="currentColor"/>
    </g>
  </g>
</svg>
`

const EyeSvg = (props: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  return <div {...props} dangerouslySetInnerHTML={{ __html: img }} />
}

export default EyeSvg
